var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadingpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66663 8C6.87577 8 8.66663 6.20914 8.66663 4C8.66663 1.79086 6.87577 0 4.66663 0C2.45749 0 0.666626 1.79086 0.666626 4C0.666626 6.20914 2.45749 8 4.66663 8Z",
    fill: "#AD826E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingpoint);
export default __webpack_public_path__ + "static/media/readingpoint.7b53af55ce85cb204354479e0ee1e2c5.svg";
export { ForwardRef as ReactComponent };